import React from 'react';
import { EclipsePackagePickerModule } from '../modules/eclipse-package-picker.module';

export const Application = () => {
  const { basename } = EclipsePackagePickerModule.internals.useContext();
  return (
    <EclipsePackagePickerModule.internals.components.AppRouter
      basename={basename}
    />
  );
};
